import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.healthcheck.BookHealthcheck';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class BookHealthcheck extends RpcClass{

    /**
     *  @class BookHealthcheck
     *  @alias module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck
     *  
     * */
    constructor(){
        super();

        /** @type {module:src/server/com/silkplm/model/plm/EAN.EAN[]}  */
        this.EANList = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {number}  */
        this.accidents = null;
        /** @type {number}  */
        this.age = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.authorFirstName = null;
        /** @type {string}  */
        this.authorLastName = null;
        /** @type {string}  */
        this.catName = null;
        /** @type {string}  */
        this.categoryId = null;
        /** @type {number}  */
        this.code = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {string}  */
        this.defaultTextField = null;
        /** @type {string}  */
        this.dictStatus = null;
        /** @type {string}  */
        this.dictStatusNullable = null;
        /** @type {string[]}  */
        this.emails = null;
        /** @type {string}  */
        this.fieldX = null;
        /** @type {string}  */
        this.firstChapter = null;
        /** @type {string}  */
        this.firstName = null;
        /** @type {string}  */
        this.group = null;
        /** @type {string}  */
        this.id = null;
        /** @type {string}  */
        this.isbn = null;
        /** @type {string}  */
        this.mixinField = null;
        /** @type {string}  */
        this.multilineTextField = null;
        /** @type {string[]}  */
        this.notes = null;
        /** @type {Date}  */
        this.oneDay = null;
        /** @type {LocalDate}  */
        this.oneDay2 = null;
        /** @type {string}  */
        this.parentCat = null;
        /** @type {BigDecimal}  */
        this.price = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {string}  */
        this.subGroup = null;
        /** @type {string}  */
        this.suppliedOptions = null;
        /** @type {string}  */
        this.title = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: Book Digest
     * @returns {Promise<BookDigest>}
     */

    async getBookDigest(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "bookId",
            "com.silkplm.model.healthcheck.BookDigest");
   }

    /**
     * Get list of detail Book Review To Book
     * @returns {Promise<BookReviewToBook[]>}
     */

    async listBookReviewToBook(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.healthcheck.templates.BookReviewToBook",
        "bookId");
    }
    /**
     * Get list of detail Book Parent Cat Review To Book
     * @returns {Promise<BookParentCatReviewToBook[]>}
     */

    async listBookParentCatReviewToBook(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.healthcheck.templates.BookParentCatReviewToBook",
        "bookId");
    }
    /**
     * Get list of detail Book Test
     * @returns {Promise<BookTest[]>}
     */

    async listBookTest(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.healthcheck.templates.BookTest",
        "bookId");
    }

    /** @type {string}  */
    get categoryIdParentId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['categoryIdParentId'] : null, this.__metadata__['categoryIdParentId']?.remoteType);
    }
    set categoryIdParentId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getCategoryIdParentIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryIdParentId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getCategoryIdParentIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryIdParentId'); //  false 
    }

    /** @returns {Promise<BookCategory>} */
    getCategoryIdParentIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryIdParentId',  allowRemote); //  false 
    }

    /** @type {number}  */
    get computedCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedCategory'] : null, this.__metadata__['computedCategory']?.remoteType);
    }
    set computedCategory(val){
    }

    /** @returns {Promise<String>} */
    getComputedCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'computedCategory', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputedCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'computedCategory'); //  true 
    }

    /** @returns {Promise<BookCategory>} */
    getComputedCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'computedCategory',  allowRemote); //  true 
    }

    /** @type {number}  */
    get computedField(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedField'] : null, this.__metadata__['computedField']?.remoteType);
    }
    set computedField(val){
    }


    /** @type {BigDecimal}  */
    get computedPrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedPrice'] : null, this.__metadata__['computedPrice']?.remoteType);
    }
    set computedPrice(val){
    }


    /**
     * @param val {module:src/server/com/silkplm/model/plm/EAN.EAN[]}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withEANList(val){
        this.EANList = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withAccidents(val){
        this.accidents = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withAge(val){
        this.age = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withAuthorFirstName(val){
        this.authorFirstName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withAuthorLastName(val){
        this.authorLastName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withCatName(val){
        this.catName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withCategoryId(val){
        this.categoryId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryId'); //  true 
    }

        /** @returns {Promise<BookCategory>} */
    getCategoryIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'categoryId', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withCode(val){
        this.code = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withDefaultTextField(val){
        this.defaultTextField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withDictStatus(val){
        this.dictStatus = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDictStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatus', allowRemote); //  true 
    }

    /** @returns {String} */
        getDictStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatus'); //  true 
    }

        /** @returns {Promise<BookStatusDict>} */
    getDictStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatus', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withDictStatusNullable(val){
        this.dictStatusNullable = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDictStatusNullableLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatusNullable', allowRemote); //  true 
    }

    /** @returns {String} */
        getDictStatusNullableStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatusNullable'); //  true 
    }

        /** @returns {Promise<BookStatusDict>} */
    getDictStatusNullableEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.BookStatusDict', 'dictStatusNullable', allowRemote); //  true 
    }

    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withEmails(val){
        this.emails = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withFieldX(val){
        this.fieldX = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withFirstChapter(val){
        this.firstChapter = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withFirstName(val){
        this.firstName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withGroup(val){
        this.group = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withIsbn(val){
        this.isbn = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withMixinField(val){
        this.mixinField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withMultilineTextField(val){
        this.multilineTextField = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withOneDay(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.oneDay = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withOneDay2(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.oneDay2 = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withParentCat(val){
        this.parentCat = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getParentCatLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'parentCat', allowRemote); //  true 
    }

    /** @returns {String} */
        getParentCatStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'parentCat'); //  true 
    }

        /** @returns {Promise<BookCategory>} */
    getParentCatEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.healthcheck.multifk.tree.BookCategory', 'parentCat', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withPrice(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.price = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withSubGroup(val){
        this.subGroup = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withSuppliedOptions(val){
        this.suppliedOptions = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withTitle(val){
        this.title = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/healthcheck/BookHealthcheck.BookHealthcheck}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<BookHealthcheck>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadBookHealthcheck(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'categoryIdParentId'){
            return this.getCategoryIdParentIdLabel(allowRemote);
        }
        if(fiendName === 'categoryId'){
            return this.getCategoryIdLabel(allowRemote);
        }
        if(fiendName === 'dictStatus'){
            return this.getDictStatusLabel(allowRemote);
        }
        if(fiendName === 'dictStatusNullable'){
            return this.getDictStatusNullableLabel(allowRemote);
        }
        if(fiendName === 'parentCat'){
            return this.getParentCatLabel(allowRemote);
        }
        if(fiendName === 'computedCategory'){
            return this.getComputedCategoryLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'categoryId'){
            return this.getCategoryIdEntity(allowRemote);
        }
        if(fiendName === 'dictStatus'){
            return this.getDictStatusEntity(allowRemote);
        }
        if(fiendName === 'dictStatusNullable'){
            return this.getDictStatusNullableEntity(allowRemote);
        }
        if(fiendName === 'parentCat'){
            return this.getParentCatEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<BookHealthcheck>}
 */
async function loadBookHealthcheck(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<BookHealthcheck[]>}
 */
async function listBookHealthcheck(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelBookHealthcheck(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<BookHealthcheck>}
 */
BookHealthcheck.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<BookHealthcheck[]>}
 */
BookHealthcheck.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<BookHealthcheck[]>}
 */
BookHealthcheck.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<BookHealthcheck[]>}
 */
BookHealthcheck.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<BookHealthcheck>}
 */
BookHealthcheck.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return BookHealthcheck.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
BookHealthcheck.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
BookHealthcheck.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
BookHealthcheck.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
BookHealthcheck.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
BookHealthcheck.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EANList'] = {'remoteType' : 'module:src/server/com/silkplm/model/plm/EAN.EAN[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/EAN.EAN[]', 'mapped' : 'false'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['accidents'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['age'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['authorFirstName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['authorLastName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['catName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['categoryId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['code'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['defaultTextField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dictStatus'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dictStatusNullable'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['emails'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['fieldX'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['firstChapter'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['firstName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['group'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['isbn'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['mixinField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['multilineTextField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['oneDay'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['oneDay2'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['parentCat'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['price'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['subGroup'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['suppliedOptions'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['title'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computedCategory'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computedField'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['computedPrice'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['categoryIdParentId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.healthcheck.BookHealthcheck';
metadata.__type_short__ = 'BookHealthcheck';
BookHealthcheck.prototype.__metadata__ = metadata;

BookHealthcheck.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/healthcheck/BookHealthcheck */
export default BookHealthcheck

export { BookHealthcheck , loadBookHealthcheck, listBookHealthcheck, labelBookHealthcheck }
